import { Message } from 'iview';
Message.config({
  duration: 15
})
// 填寫資料 旅平險 旅遊條件
export const model = {
  abroad: false,//abroad: true, 20201111 Wen modify 因應新冠肺炎 停止國外旅遊
  travelArea: [{ state: null ,country: null}],
  startTime: { date: '',time: ''},
  endTime: { date: '',time: ''},
  expectPremium: ''
};

//import format from 'date-fns/format';
export const accidentmodel = {
  //isbuy:false,
  //otherjob: false,
  startTime: { date: ''},    
  expectPremium: '' ,
  //jobcontent:[{label:'null',value:null}] ,//20210316
  accidentArea :{label:'0001001 內勤人員',value:'0001001 內勤人員 1'}//{value: ''}//{label: '',value: ''}  //20210312 {label:null,value:null} //20210316[{label:null,value:null}]

};

export const petmodel = {
        //typeOfPet:'',
        //dateOfBirthPet: {
        //  year: '',
        //  month: '',
        //  day: '' 
        //  },
        //expectPremium: '',
       
        petName:'',
        petGender:'M',
        petNo:'',
        petBreed:'',
        petColor:'',
        petWeight:0,
        petDesc:'',
        petPhoto:'',
        filename:''
};

export const vaccineModel = {
  vaccineInceptionDate :''
}

const travelAreaValidator = async ( rule, value, callback ) => {
  let itemsIsEmpty = [];
  let countryValue = [];
  let errorMsg = [];
  await value.filter((val) => {
    const itemIsEmpty = Object.values(val).some(val => !val);
    itemsIsEmpty.push(itemIsEmpty);
    countryValue.push(val.country);
  });
  await itemsIsEmpty.filter((val) => {
    if(val === true) {
      errorMsg.push("旅遊地區不得為空值");
    }
  })
  const noRepeatItems = await [...(new Set(countryValue))];
  if(countryValue.length !== noRepeatItems.length) {
    errorMsg.push("旅遊地區不得重覆");
  };
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
} 
const startTimeValidator =  (rule, value, callback ) => {
  const { date, time } = value;
  //const diffter = differenceInHours(`${date} ${time}`, new Date());
  const datedealine = Date.now() + 3600000;
  //const datedealine = moment(new Date()).add(1, 'hours').format('YYYY-MM-DD hh:mm:ss');
  const diffter = new Date(`${date} ${time}`) - new Date(datedealine);
  let errorMsg = [];
  if(!date) {
    errorMsg.push("請選擇您旅遊的出發日期");
  }
  if(!time) {
    errorMsg.push("請選擇您旅遊的出發時間");
  }
  //console.log(datedealine);
  //console.log(new Date(`${date} ${time}`));
  if (diffter < 1) {   //Wen Add 2019/11/28 控制無法選擇過去的時間點
    //console.log(`${date} ${time}`);
    //console.log("insuFilterForm-if"+diffter);
    errorMsg.push("出發時間需大於目前時間1小時");
  }//else{
  //console.log(`${date} ${time}`);
  //console.log("insuFilterForm-else"+diffter);
  //}
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}
const endTimeValidator =  ( rule, value, callback ) => {
  const { date, time } = value;
  let errorMsg = [];
  if(!date) {
    errorMsg.push("請選擇您旅遊的結束日期");
  }
  if(!time) {
    errorMsg.push("請選擇您旅遊的結束時間");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}
const expectPremiumValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請選擇您的期望保費");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}
const accidentRule = {
  type: 'object', 
  required: true,
  fields: {
    label: [
      { type: 'string', required: true, message: '12345職業類別' }//, trigger: 'validate'
    ],
    value: [
      { type: 'string', required: true, message: '6666職業類別' }
    ]
  },
  trigger: 'validate'
};


const accidentcontentValidator = async ( rule, value, callback ) => {
  let itemsIsEmpty = [];
  let countryValue = [];
  let errorMsg = [];
  await value.filter((val) => {
    const itemIsEmpty = Object.values(val).some(val => !val);
    itemsIsEmpty.push(itemIsEmpty);
    countryValue.push(val.value);
  });
  await itemsIsEmpty.filter((val) => {
    if(val === true) {
      errorMsg.push("職業內容不得為空值----");
    }
  })
  const noRepeatItems = await [...(new Set(countryValue))];
  if(countryValue.length !== noRepeatItems.length) {
    errorMsg.push("旅遊地區不得重覆");
  };
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
} 

const accidentAreaValidator = async ( rule, value, callback ) => {
  let itemsIsEmpty = [];
  let countryValue = [];
  let errorMsg = [];  
  //const {label,value }= values;
 
 //console.log("accidentAreaValidator:"+value);
 if(!value) {
  errorMsg.push("請選擇您的職業內容-------------");
}

 if(!value.value) {
  errorMsg.push("請選擇您的職業內容00000");
}
 if(value.value='') {
  errorMsg.push("請選擇您的職業內容");
}/*
console.log("accidentAreaValidator:"+value.value);*/
/*
if(!label) {
  errorMsg.push("請選擇您的職業內容00");
}
if(value==='') {
  errorMsg.push("請選擇您的職業內容1");
}
if(label=='') {
  errorMsg.push("請選擇您的職業內容2");
}

  await value.filter((val) => {
    const itemIsEmpty = Object.values(val).some(val => !val);
    itemsIsEmpty.push(itemIsEmpty);
    countryValue.push(val.jobtype);
  });
  await itemsIsEmpty.filter((val) => {
    if(val === true) {
      errorMsg.push("職業內容不得為空值3");
    }
  })*/
  /*const noRepeatItems = await [...(new Set(countryValue))];
  if(countryValue.length !== noRepeatItems.length) {
    errorMsg.push("旅遊地區不得重覆");
  };*/
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  console("1222222222");
  callback();
} 

const isotherjobValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  //console.log("isotherjobValidator-value:"+value);
  if(value === true) {
    errorMsg.push("如有兼職，則無法使用網路投保。");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}

const accidentJobLvValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請選擇您的職業等級");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}

const accidentDateValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請選擇您傷害險的生效日期");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}
//petInceptionDateValidator
const petInceptionDateValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請選擇您寵物險的生效日期");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}

const vaccineInceptionDateValidator = ( rule, value, callback ) => {
  let errorMsg = [];
  const date =value;
  const datedealine = new Date(Date.now()+432000000).toISOString().substring(0,10);//20220415 生效日期改為 T+5//new Date(Date.now()+86400000).toISOString().substring(0,10);//Date.now() + 86400000;
  //const diffter = differenceInCalendarDays(`${date}`, new Date());  
  const diffter = new Date(`${date}`) - new Date(datedealine); 
  //console.log("diffter-++"+datedealine);
  //console.log("diffter++"+JSON.stringify(diffter));
  if (isNaN(diffter)|| value=='') {        
    errorMsg.push("請選擇您疫苗險防疫險的生效日期!");        
  }        
  //console.log(diffter);
  if (diffter < 0) {
    //Wen Add 2020/05/30 控制無法選擇過去的時間點       
    errorMsg.push("目前保險生效時間是從零時起，保險生效日為T+5");
    //errorMsg.push("保險生效日是從零時起，無法選擇過去的時間");
  }
  /*  if(!value) {
    errorMsg.push("請選擇您疫苗險防疫險的生效日期2");
  }*/
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}
const petNameValidator = (rule, value, callback) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請輸入寵物名字");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}

const petGenderValidator = (rule, value, callback) => {
  let errorMsg = [];
  if(!value) {
    errorMsg.push("請輸入寵物的性別");
  }
  if(errorMsg.length > 0) {
    errorMsg.forEach((value,index) => {
      Message.warning({
        render: h => {
            return h('div',[h('div', errorMsg[index])]);
        },
        closable: true
      });
      return callback(new Error(value));
    })
  }
  callback();
}

  const petNoValidator = (rule, value, callback) => {
    let errorMsg = [];
    if(!value) {
      errorMsg.push("請輸入寵物的晶片號碼");
    }
    if(value.length<10) {  //||value.length!=15
      errorMsg.push("請輸入寵物晶片號碼長度為10~15碼");
    }
    
    if(errorMsg.length > 0) {
      errorMsg.forEach((value,index) => {
        Message.warning({
          render: h => {
              return h('div',[h('div', errorMsg[index])]);
          },
          closable: true
        });
        return callback(new Error(value));
      })
    }
    callback();
  }

  const petBreedValidator=(rule, value, callback) => {
    let errorMsg = [];
    if(!value) {
      errorMsg.push("請輸入寵物的品種");
    }
    if(errorMsg.length > 0) {
      errorMsg.forEach((value,index) => {
        Message.warning({
          render: h => {
              return h('div',[h('div', errorMsg[index])]);
          },
          closable: true
        });
        return callback(new Error(value));
      })
    }
    callback();
  }

  const petColorValidator=(rule, value, callback) => {
    let errorMsg = [];
    if(!value) {
      errorMsg.push("請輸入寵物的毛色");
    }
    if(errorMsg.length > 0) {
      errorMsg.forEach((value,index) => {
        Message.warning({
          render: h => {
              return h('div',[h('div', errorMsg[index])]);
          },
          closable: true
        });
        return callback(new Error(value));
      })
    }
    callback();
  }

  const petWeightValidator = ( rule, value, callback ) => {
    let errorMsg = [];
    if(!value) {
      errorMsg.push("請輸入您的寵物體重");
    } 
    const isNumber = /^\d*$/.test(value); 
    if(!isNumber) {
      errorMsg.push("體重僅能輸入數字");
    }
    if(errorMsg.length > 0) {
      errorMsg.forEach((value,index) => {
        Message.warning({
          render: h => {
              return h('div',[h('div', errorMsg[index])]);
          },
          closable: true
        });
        return callback(new Error(value));
      })
    }
    callback();
  }
  const petPhotoValidator = ( rule, value, callback ) => {
    let errorMsg = [];
    //console.log(value);
    //console.log(value.data);
    if(!value) {
      errorMsg.push("請上傳您寵物的照片");
    }
    if (!value.filter('image'))
    {      
      errorMsg.push("請確認上傳照片的格式!需為PNG或JPG");
    }
    if (!value.filter('jpg')||!value.filter('png'))
    {      
      errorMsg.push("請確認上傳照片的格式為PNG或JPG");
    }
    
    if(errorMsg.length > 0) {
      errorMsg.forEach((value,index) => {
        Message.warning({
          render: h => {
              return h('div',[h('div', errorMsg[index])]);
          },
          closable: true
        });
        return callback(new Error(value));
      })
    }
    callback();
  }
  
export const rules = {
  travelArea: {
    type: 'array',
    required: true,
    max: 4,
    validator: travelAreaValidator,
    trigger: 'validate'
  },
  startTime: {
    type: 'object',
    required: true,
    validator: startTimeValidator,
    trigger: 'validate'
  },
  endTime: {
    type: 'object',
    required: true,
    validator: endTimeValidator,
    trigger: 'validate'
  },
  expectPremium: { 
    type: 'number',
    required: true,
    validator: expectPremiumValidator,
    trigger: 'validate'
  },
};


export const accidentrules = { 
  accidentArea: {
    type: 'object',
    required: true,
    //max: 1,
    validator: accidentcontentValidator,//accidentRule,//accidentAreaValidator,//20210316
    trigger: 'validate'
  },
  //accidentArea:accidentRule,
  /*jobcontent: {
    type: 'array',
    required: true,
    max: 1,
    validator: accidentcontentValidator,
    trigger: 'validate'
  },*/
  accidentdate: {
    type: 'object',
    required: true,
    validator: accidentDateValidator,
    trigger: 'validate'
  },
  /*endTime: {
    type: 'object',
    required: true,
    validator: endTimeValidator,
    trigger: 'validate'
  },*/
  expectPremium: { 
    type: 'number',
    required: true,
    validator: accidentJobLvValidator,
    trigger: 'validate'
  },
  otherjob:{
    validator: isotherjobValidator,
    trigger: 'change'
  }
};

export const petrules = {
/*
petName:'',
        petGender:'',
        petNo:'',
        petBreed:'',
        petColor:'',
        petWeight:0
*/  petInceptionDate:{
      type: 'object',  //object
      required: true,
      validator: petInceptionDateValidator,
      trigger: 'validate'
    },
    petName: {
      type: 'string',
      required: true,
      validator: petNameValidator,
      trigger: 'validate'
    },
    petGender: {
        type: 'string',
        required: true,
        validator: petGenderValidator,
        trigger: 'validate'
    },
    petNo: {
      type: 'string',
      required: true,
      validator: petNoValidator,
      trigger: 'validate'
    },
    petBreed: {
      type: 'string',
      required: true,
      validator: petBreedValidator,
      trigger: 'validate'
    },
    petColor: {
      type: 'string',
      required: true,
      validator: petColorValidator,
      trigger: 'validate'
    },
    petWeight: { 
      type: 'number',
      required: true,
      validator: petWeightValidator,
      trigger: 'validate'
    },
   /* filename:{
      type: 'string',
      required: true,
      validator: petPhotoValidator,
      trigger: 'validate'
    }*/
};

export const vaccinerules = {
  vaccineInceptionDate:{
    type: 'object',  //object
    required: true,
    validator: vaccineInceptionDateValidator,
    trigger: 'validate'
  },
};

const timeRule = {
  type: 'object',
  fields: {
    date: [{ type: 'string', required: true, message: '請選擇您的出發日期' }],
    time: [{ type: 'string', required: true, message: '請輸入您的出發時間' }]
  },
  tirgger: 'validate'
};
const expectPremiumRule = { 
  required: true,
  trigger: 'blur',
  message: '請選擇您的期望保費'
};